<template>
    <v-row no-gutters>
      <v-col :cols="11" :xm="11" :sm="11" :md="11">
        <v-text-field
          :value="value"
          :min="min"
          :max="max"
          :label="label"
          :clearable="clearable"
          :outlined="outlined"
          @click:clear="$emit('input', null)"
          @keydown="keydown"
          @input="input"
          hide-details="auto"
          class="mr-1"
          >
        </v-text-field>
      </v-col>

      <v-col :cols="1" :xs="1" :sm="1" :md="1">
        <v-row no-gutters>
          <v-btn small icon @click="increment">
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-row>
        <v-row no-gutters>
          <v-btn small icon @click="decrement">
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
export default {
  name: 'NumberField',
  props: {
    value: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 25
    },
    clearable: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    keydown (e) {
      const key = e.key

      // if any one of the following keystrokes - ok
      if (key === 'Backspace' 
        || key === 'Delete'
        || key === 'ArrowLeft'
        || key === 'ArrowRight') return

      // if NaN - abort
      const pattern = /[0-9]/g;
      if (!pattern.test(key)) e.preventDefault()

      // if nothing entered yet - ok
      if (this.value === null) return

      // if any part of the text is selected - ok
      if (e.currentTarget.selectionEnd > e.currentTarget.selectionStart) return

      // if the new value will be greater than "max" - abort
      const existingValue = this.value.toString()
      const newValue = parseInt(existingValue + key)
      if (newValue > this.max) e.preventDefault()
    },
    input (e) {
      if (e.length > 0) this.$emit('input', parseInt(e))
      else this.$emit('input', null)
    },
    increment () {
      var number = this.value + 1
      if (number > this.max) number = this.max
      this.$emit('input', number)
    },
    decrement () {
      var number = this.value - 1
      if (number < this.min) number = this.min
      this.$emit('input', number)
    }
  }
}
</script>